import React from "react";
import PropTypes from "prop-types";
import ConnectedAccountCTAActivateAccountBadge from "./ConnectedAccountCTAActivateAccountBadge";
import ConnectedFundraisingAltImage from "./ConnectedFundraisingAltImage";
import ConnectedFundraisingDashboardButton from "./ConnectedFundraisingDashboardButton";
import ConnectedAccountCTAAccountForm from "./ConnectedAccountCTAAccountForm";
import "./AccountCTA.scss";

// Handles the Section Heading text which needs to have a %FirstName% tag
// replaced within the CMS text
const AccountCTASectionHeading = ({
    sectionHeading,
    renderSectionHeading = (_sectionHeading) => <h2>{_sectionHeading}</h2>,
}) => <>{renderSectionHeading(sectionHeading)}</>;

AccountCTASectionHeading.propTypes = {
    sectionHeading: PropTypes.string.isRequired,
    renderSectionHeading: PropTypes.func,
};

const AccountCTA = ({
    isFundraisingParticipant,
    additionalText,
    sectionHeading,
    renderSectionHeading = (_sectionHeading) => <h2>{_sectionHeading}</h2>,
}) => {
    // Only render the Account CTA if the user is a fundraising participant
    if (isFundraisingParticipant) {
        return (
            <div className="account-cta grid">
                <div className="col col--12 -padding-bottom--15">
                    <div className="account-cta__content -callout">
                        <ConnectedAccountCTAActivateAccountBadge />
                        <ConnectedFundraisingAltImage />
                        <div className="grid">
                            <div className="col col--12">
                                <AccountCTASectionHeading
                                    sectionHeading={sectionHeading}
                                    renderSectionHeading={renderSectionHeading}
                                />
                            </div>
                        </div>
                        <div className="grid">
                            <div className="col col--12">
                                <p>{additionalText}</p>
                            </div>
                        </div>
                        <ConnectedFundraisingDashboardButton />
                        <ConnectedAccountCTAAccountForm />
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

AccountCTA.propTypes = {
    isFundraisingParticipant: PropTypes.bool.isRequired,
    additionalText: PropTypes.string.isRequired,
    sectionHeading: PropTypes.string.isRequired,
    renderSectionHeading: PropTypes.func,
};

export default AccountCTA;
